import React, { useState } from "react";
import {
  Menu,
  Accordion,
} from "semantic-ui-react";
import './Explorerbar.css'
import { useSelector } from "react-redux";
import { getDatabases } from "../../features/tableData/visualSlice";


const Examplesbar = () => {
  const [activeItemIdx, setActiveItemIdx] = useState(-1);
  const databases = useSelector(getDatabases);

  const handleItemClick = (index) => {
    if(activeItemIdx === index){
      setActiveItemIdx(-1);
    }
    else{
      setActiveItemIdx(index);
    }
  };

  return (
          <>
            <Menu.Item>
              Examples
            </Menu.Item>
           
            {databases[0].name === "ecommerce" && <Menu.Item className="no_padding_accordian">
              <Accordion fluid>  
                <Accordion.Title
                  active={activeItemIdx === 0}
                  onClick={() => handleItemClick(0)}
                >
                  <a href="https://www.youtube.com/watch?v=ML_Qw0-HXes" target="_blank" rel="noreferrer"> Data Explainer</a>
                </Accordion.Title>

                <Accordion.Title
                  active={activeItemIdx === 1}
                  onClick={() => handleItemClick(1)}
                >
                  <a href="https://www.youtube.com/watch?v=8HmbjASuvMI" target="_blank" rel="noreferrer"> Sample Easy Queries</a>
                </Accordion.Title>

                <Accordion.Title
                  active={activeItemIdx === 2}
                  onClick={() => handleItemClick(2)}
                >
                  <a href="https://www.youtube.com/watch?v=VhtqbxDFj7w" target="_blank" rel="noreferrer"> Sample Advanced Queries</a>
                </Accordion.Title>

  
            </Accordion>
            </Menu.Item>
          }
          </>
  );
};

export default Examplesbar;